import { Component, Input, OnChanges } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgStyle, NgClass, NgIf } from '@angular/common';
import { CountdownDirective } from '../../directives/countdown.directive';

@Component({
    selector: 'app-offer-card',
    templateUrl: './offer-card.component.html',
    styleUrl: './offer-card.component.scss',
    imports: [RouterLink, NgStyle, NgClass, NgIf, CountdownDirective]
})
export class OfferCardComponent implements OnChanges {
  @Input() id: string | null = null;
  @Input() title: string | null = null;
  @Input() description: string | null = null;
  @Input() image: string | null = null;
  @Input() expirationDate: string | null = null;

  constructor() { }

  ngOnChanges(changes: any): void {
    this.description = changes.description?.currentValue.replace(/<[^>]*>?/gm, '');
  }
}
